const Career = () => {
  return (
    <div className="about-us" id="karijera">
      <div className="about-us-all-page">
        <div className="about-us-title">Postanite deo našeg tima</div>
        <div className="about-us-page">
          <div className="about-us-left">
            <img
              src="/images/karijera.jpg"
              className="ison-about-us-left"
              alt="triotim"
            />
          </div>
          <div className="about-us-right">
            <div className="about-us-right-all-text">
              <div className="about-us-right-text">
                Ukoliko ste motivisani ka poslovnim uspesima i radu u mladom
                timu sa kojim zajedno možete da gradite uspešnu poslovnu
                budućnost, pozivamo Vas da nam pošaljete svoju radnu biografiju.
              </div>

              <div className="about-us-right-text">
                Ukoliko želite da postanete deo našeg tima, pošaljite Vašu radnu
                biografiju sa propratnim pismom na email adresu
                office@triotim.rs.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Career;
